<template>
	<div id="login-app" class="ss-login">
		<div v-if="view === 'sign-in'">
			<el-card class="ss-login-card">
				<div v-if="passcode === false">
					<div class="form-group d-block ss-email" :class="[{'has-error': errors.has('email')}]">
						<label class="text-primary" for="ss-email">Email Address*</label>
						<el-input id="ss-email" v-model="data.email" name="email" data-vv-as="email" class="w-100" v-validate="'required|email'" />
						<span v-if="errors.has('email')">{{errors.first('email')}}</span>
					</div>
					<div class="form-group d-block ss-password" :class="[{'has-error': errors.has('password')}]">
						<label class="text-primary" for="ss-password">Password*</label>
						<el-input id="ss-email" type="password" v-model="data.password" name="password" data-vv-as="password" class="w-100" v-validate="'required'" />
						<span v-if="errors.has('password')">{{errors.first('password')}}</span>
					</div>

					<div class="form-group d-block ss-login-checkbox">
						<el-checkbox v-model="data.remember">
							<el-tooltip popper-class="ss-tooltip" effect="dark" content="We will keep you signed in longer, even if you close your browser." placement="top">
								<el-button @click.prevent="data.remember = !data.remember" type="text">Keep me signed in</el-button>
							</el-tooltip>
						</el-checkbox>
					</div>

					<div class="form-group d-flex align-items-center ss-login-buttons">
						<el-button type="primary" class="login-btn" @click.prevent="signIn" :loading="thinking.signIn">
							Login
						</el-button>

						<div class="ml-3">
							<a style="cursor: pointer" class="reset-btn" @click.prevent="serverStatus = null; findMyLogin = true">
								Forgot Login?
							</a><br />
							<a style="cursor: pointer" class="reset-btn" @click.prevent="serverStatus = 401">
								Forgot Password?
							</a>
						</div>


						

					</div>

				</div>
				
				<div v-if="serverError">
					<el-alert type="error" :closable="false">
						{{serverError}}
					</el-alert>
				</div>
				
				<div v-if="!lockedOut">
					<div v-if="findMyLogin || serverStatus !== null">

						<!-- 401 means they entered a correct email but incorrect password -->
						<div v-if="serverStatus === 401" class="mt-2">
							<p class="text-primary">
								If you'd like, we can send a temporary passcode to your phone so you can reset your password, or send a link by email.
							</p>
							
							<div class="d-block">
								<el-input v-model="data.cell" style="width: 300px" placeholder="Enter your cell">
									<el-button slot="append" :loading="thinking.sendCode" :disabled="data.cell === null || data.cell.length < 14" @click.prevent="generatePasscode">Send SMS</el-button>
								</el-input>
							</div>									
							<div v-if="last2Phone"><small>(###) ###-##{{last2Phone}}</small></div>
							
							<div class="d-block mt-2 form-group">
								<el-button :disabled="disabled.sendEmail" :loading="thinking.sendEmail" type="link" @click.prevent="generateEmail">Send By Email</el-button>
							</div>
							
							<div class="mt-2" v-if="passcode === true">

								<p class="text-primary">
									Two steps to change your password:
									<ol>
										<li>Enter the passcode below.</li>
										<li>Enter a new password.</li>
									</ol>
								</p>

								<div class="row">
									<div class="form-group col-md-4 d-block" :class="[{'has-error': errors.has('recover.passcode')}]">
										<label class="text-primary" for="ss-passcode">Passcode*</label>
										<el-input data-vv-scope="recover" id="ss-passcode" type="number" v-model="data.passcode" name="passcode" data-vv-as="passcode" class="w-100" v-validate="'required'" />
										<span v-if="errors.has('recover.passcode')">{{errors.first('recover.passcode')}}</span>
									</div>

									<div class="form-group col-md-5 d-block" :class="[{'has-error': errors.has('recover.newpassword')}]">
										<label class="text-primary" for="ss-newpassword">Password* <small>7-20 characters - no spaces</small></label>
										<el-input style="width: 215px" show-password data-vv-scope="recover" id="ss-newpassword" type="password" v-model="data.newPassword" name="newpassword" data-vv-as="new password" class="w-100" v-validate="{ required: true, regex:/^\S{7,20}$/ }" />
										<span v-if="errors.has('recover.newpassword')">{{errors.first('recover.newpassword')}}</span>
									</div>
								</div>

								<el-button :loading="thinking.recover" @click.prevent="verifyPasscode">Sign In</el-button>&nbsp;
								<a style="cursor: pointer" @click="startOver">Start Over</a>

							</div>

						</div>

						<!-- 404 means they entered an email address that does not exist in the database -->
						<div v-else-if="serverStatus === 404" class="mt-2">
							<p class="text-primary">
								We couldn't find {{couldNotFind}} in our records. If you're sure you've created an account, you have a couple options. You can either <a href="/service" class="text-danger" target="_blank"><strong>click here</strong></a> to access our service department for direct support, or we can try finding your account with your cell phone.
							</p>

							<el-input v-model="data.cell" style="width: 290px" placeholder="Enter your phone number">
								<el-button slot="append" :loading="thinking.search" :disabled="data.cell === null || data.cell.length < 14" @click.prevent="lookupByPhone">Search</el-button>
							</el-input>

						</div>

						<!-- This will show if they immediately click find my login when there is no previous failed attempts -->
						<div v-else-if="findMyLogin && serverStatus === null" class="mt-2">
							<p class="text-primary">
								If you're sure you've created an account, you have a couple options. You can either <a href="/service" class="text-danger" target="_blank"><strong>click here</strong></a> to access our service department for direct support, or we can try finding your account with your cell phone.
							</p>

							<el-input v-model="data.cell" style="width: 290px" placeholder="Enter your phone number">
								<el-button slot="append" :loading="thinking.search" :disabled="data.cell === null || data.cell.length < 14" @click.prevent="lookupByPhone">Search</el-button>
							</el-input>

						</div>
					</div>
				</div>
				<div v-else>
					<p class="text-primary">
						Please <a href="/service" class="text-danger" target="_blank"><strong>click here</strong></a> to access our service department.
					</p>
				</div>
				


			</el-card>
		</div>
		<div v-else>
			<recover :data="data" :server-status="serverStatus" @view="view = $event"></recover>
		</div>
		
	</div>
</template>

<script>

	import Vuex from 'vuex';
	import Recover from "./views/Recover.vue";
	import { rest } from "@/utilities/rest.js";
	export default {
		data() {
			return {

				data: {
					email: null,
					password: null,
					remember: false,
					cell: null,
					passcode: null,
					newPassword: null
				},

				disabled: {
					sendCode: false,
					sendEmail: false
				},

				passcode: false,
				passcodeSuccess: false,

				couldNotFind: null,
				last2Phone: null,
				watch: {
					invalidEmails: []
				},

				thinking: {
					signIn: false,
					search: false,
					sendCode: false,
					sendEmail: false,
					recover: false
				},

				view: "sign-in",
				serverError: null,
				serverStatus: null,
				lockedOut: false,
				findMyLogin: false,
				foundEmail: null

				
			}
		},

		components: {
			[Recover.name]: Recover
		},

		methods: {
			signIn() {
				this.resetHelp();
				this.$validator.validateAll().then(valid => {
					if (valid) {
						this.thinking.signIn = true;
						
						rest.post("Login/", "SignIn", "json", JSON.stringify(this.data)).done(response => {
							document.location.href = document.location.protocol + "//" + document.location.host + this.getParameterByName("returnUrl");				
						}).fail(xhr => {
							console.log(xhr);
							var err = JSON.parse(xhr.responseText);
							this.serverStatus = xhr.status;
							if (xhr.status === 404) {
								this.couldNotFind = this.data.email;															
							} else if (xhr.status === 401) {
								this.serverError = err.errorMessage;	
								this.last2Phone = err.last2Phone;
								if (this.serverError.indexOf("temporarily locked") > -1) {
									this.lockedOut = true;
								}
							}							
						}).always(() => {
							this.thinking.signIn = false;
						});
					}
				});

			},

			lookupByPhone() {
				this.thinking.search = true;
				
				rest.get("Login/", "GetMaskedEmailFromCell", "json", { cell: this.data.cell }).done(response => {
					if (response !== null) {
						this.$alert("<p>The following email (partially hidden for security purposes) was found: " + response + ". Try to sign in again.</p>", "", {
							dangerouslyUseHTMLString: true
						});

						this.resetHelp();
						
					} else {
						this.$alert("We could not find a login associated with that number.");
					}
					//this.$alert("")
				}).always(() => {
					this.thinking.search = false;
					
				});
			},
					

			generatePasscode() {
				this.thinking.sendCode = true;
				rest.post("Login/", "GeneratePasscode", "json", JSON.stringify({ cell: this.data.cell, email: this.data.email })).done(response => {
					this.passcode = true;
				}).fail((xhr) => {
					this.$alert(JSON.parse(xhr.responseText));
				}).always(() => {
					this.thinking.sendCode = false;
					this.disabled.sendCode = true;
					setTimeout(() => {
						this.disabled.sendCode = false;
					}, 10000);
				})
			},

			generateEmail() {
				this.thinking.sendEmail = true;
				rest.post("Login/", "GenerateEmail", "json", JSON.stringify({ email: this.data.email })).done(response => {
					this.$alert("Instructions to reset your password were sent via email. It may take a few minutes for it to arrive. Be sure to check your spam folder.");
					this.resetHelp();
				}).fail((xhr) => {
					this.$alert(JSON.parse(xhr.responseText));
					
				}).always(() => {
					this.thinking.sendEmail = false;
				})
			},

			verifyPasscode() {
				this.$validator.validateAll("recover").then(valid => {
					if (valid) {
						this.thinking.recover = true;
						
						rest.post("Login/", "VerifyPasscode", "json", JSON.stringify(this.data)).done(response => {

							document.location.href = document.location.protocol + "//" + document.location.host + this.getParameterByName("returnUrl");								
						}).fail(xhr => {
							this.$alert(JSON.parse(xhr.responseText));
							this.thinking.recover = false;
						}).always(() => {
							
						});
					}
				});
			},

			resetHelp() {
				this.passcode = false;
				this.serverError = null;
				this.serverStatus = null;
				this.findMyLogin = false;
			},

			startOver() {
				this.resetHelp();
			},

			getParameterByName(name) {
				
				var url = window.location.href;
				name = name.replace(/[[\]]/g, '\\$&');
				var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
						results = regex.exec(url);
				if (!results) return "";
				if (!results[2]) return "";
				return decodeURIComponent(results[2].replace(/\+/g, ' '));
			}
		},

		watch: {

			'data.cell': function (val) {
				if (val && val.length) {
					var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
					this.data.cell = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
				}
			},
			'data.email': function (val) {
				this.resetHelp();
			}
		}
		
	}
</script>

<style>
	#login-app {
		min-height: 400px;
	}

	.ss-tooltip {
		max-width: 300px;
	}

	i.text-muted {
		color: #cccccc !important;
	}
	ul.el-timeline {
		padding-left: 0;
	}

	.el-table .cell {
    word-break: normal;
  
	}

	.el-dropdown-menu.el-popper.el-dropdown-menu--mini {
		max-height: 200px;
		overflow-y: auto;
	}

	.el-tabs__item.is-active {
		color: #cc6600;
	}

	.el-tabs__active-bar {
		background-color: #cc6600;
	}
	.fade-enter-active,
	 .fade-leave-active {
		 transition-duration: 0.3s;
		transition-property: height, opacity;
		 transition-timing-function: ease;
		overflow: hidden;
	 }

	.profile-wrapper .account-header {

	}

	.el-message-box {
    width: 100% !important;
    max-width: 320px !important;
	}

	.profile-wrapper h2 {
		font-size: 18px;
		color:#cc6600; 
	}

	.el-dialog__body {
		word-break: break-word;
	}

	.el-button--primary.is-active, .el-button--primary:active, el-button--primary:focus, el-button--primary:hover {
		background: #cc6600 !important;
		border-color: #cc6600 !important;
		color: #FFF;
	}

	.el-button--primary {
    color: #FFF;
    background-color: #cc6600 !important;
    border-color: #cc6600 !important;
	}

	.el-button--primary:hover {
    color: #FFF;
    background-color: #cc6600;
    border-color: #cc6600;
		opacity: .9;
	}

	.el-alert--info.is-dark span {
    color: #ffffff !important;
	}

	.el-message {
		min-width: 340px !important;
	}
	
	.has-error input,
	.has-error select {
		border-color: red;
	}

	.account-header {
		position: relative;
	}

		.account-header .action {
			position: absolute;
			font-size: 25px;
			right: 0;
			top: 13px;
			cursor: pointer;
		}

	.el-button+.el-button {
    margin-left: 0px;
	}

	.el-alert p.el-alert__description {
		margin-top: 0;
	}
	.el-dialog {
		margin-top: 5vh !important;
	}

	.el-message-box {
		width: 320px;
	}

	/* Small devices (landscape phones, 576px and up) */
	@media (min-width: 576px) {

		.el-message-box {
			width: 480px;
		}

		.el-button + .el-button {
			margin-left: 15px;
		}

		.profile-wrapper h2 {
			font-size: 26px;
			font-weight: 300;
		}
	}

	/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
  @media (min-width: 768px) {  
 
  }
 
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) { 
		
  }
 
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {  
    
  }
</style>
